// import React, {
//   useLayoutEffect,
//   useRef,
//   useState,
//   useEffect,
//   useMemo,
// } from "react";

// import * as am5 from "@amcharts/amcharts5";
// import * as am5xy from "@amcharts/amcharts5/xy";
// import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
// import APP_CONFIG from "../config/appConfig";
// import Select, { components } from "react-select";

// const MAX_DEFAULT_COMPANIES = 3;
// const PANEL_SHOW_DEFAULT = 5;

// // ++++++++++++++++++++++++++++++++++++++++++++++

// const buildGroupedMetricOptions = (availableMetrics) => {
//   return Object.entries(APP_CONFIG?.METRIC_GROUPS)
//     .map(([group, metrics]) => {
//       const options = metrics
//         .filter((metric) => availableMetrics.includes(metric))
//         .map((metric) => ({
//           label: formatMetricLabel(metric),
//           value: metric,
//         }));

//       return options.length
//         ? {
//             label: group,
//             options,
//           }
//         : null;
//     })
//     .filter(Boolean);
// };

// const CollapsibleMenuList = (props) => {
//   const { children, selectProps } = props;

//   const { collapsedGroups, setCollapsedGroups } = selectProps;

//   return (
//     <components.MenuList {...props}>
//       {React.Children.map(children, (group) => {
//         if (!group?.props?.data) return group;

//         const label = group.props.data.label;

//         const isCollapsed = collapsedGroups?.includes(label);

//         return (
//           <div>
//             <div
//               onClick={(e) => {
//                 e.stopPropagation();

//                 setCollapsedGroups((prev) =>
//                   isCollapsed
//                     ? prev.filter((g) => g !== label)
//                     : [...prev, label]
//                 );
//               }}
//               style={{
//                 cursor: "pointer",
//                 fontWeight: 600,
//                 padding: "8px 12px",
//                 background: "#f8f9fa",
//                 borderBottom: "1px solid #eee",
//               }}
//             >
//               {isCollapsed ? "▶" : "▼"} {label}
//             </div>

//             {!isCollapsed && group}
//           </div>
//         );
//       })}
//     </components.MenuList>
//   );
// };

// // +++++++++++++++++++++++++++++++++++++++++++++++++++++++

// const LINE_COLORS = [
//   0x7b6ff0, 0x27ae60, 0xf39c12, 0xe74c3c, 0x2980b9, 0x8e44ad, 0x16a085,
//   0xd35400,
// ];

// const formatMetricLabel = (metric) =>
//   APP_CONFIG?.METRICS_WITH_NAMES[metric] || metric.replace(/IQ_|_/g, " ");

// const mergeUniqueCompanies = (...lists) => {
//   const map = new Map();

//   lists.flat().forEach((c) => {
//     if (c && !map.has(c.value)) {
//       map.set(c.value, c);
//     }
//   });

//   return Array.from(map.values());
// };

// const CheckboxOption = (props) => {
//   return (
//     <components.Option {...props}>
//       <input
//         type="checkbox"
//         checked={props.isSelected}
//         onChange={() => null}
//         style={{ marginRight: 8 }}
//       />
//       {props.label}
//     </components.Option>
//   );
// };

// const deriveAvailableMetrics = (financialData) => {
//   if (!financialData?.length) return [];

//   const metricSet = new Set();

//   financialData.forEach((company) => {
//     // company.metrics?.forEach((m) => {
//     company.rawFinancials?.forEach((m) => {
//       // if (m.metric && m.value !== null && m.value !== undefined) {
//       if (m._id) {
//         metricSet.add(m._id);
//       }
//     });
//   });

//   return Array.from(metricSet);
// };

// const MultiLineChart = ({ financialData = [], competitorOptions = [] }) => {
//   const chartRef = useRef(null);

//   const availableMetrics = useMemo(
//     () => deriveAvailableMetrics(financialData),
//     [financialData]
//   );

//   const groupedMetricOptions = useMemo(
//     () => buildGroupedMetricOptions([...new Set(availableMetrics)]),
//     [availableMetrics]
//   );

//   // ─────────────────────────────────────────────────────────────
//   // LOCAL STATES
//   // ─────────────────────────────────────────────────────────────

//   const [localCompanies, setLocalCompanies] = useState(() =>
//     mergeUniqueCompanies(competitorOptions).slice(0, MAX_DEFAULT_COMPANIES)
//   );

//   const [localMetric, setLocalMetric] = useState(
//     () => availableMetrics[0] || null
//   );

//   const [showCompanyFilter, setShowCompanyFilter] = useState(false);

//   const [showMetricFilter, setShowMetricFilter] = useState(false);

//   const [showAllSelectedCompanies, setShowAllSelectedCompanies] =
//     useState(false);

//   const [collapsedGroups, setCollapsedGroups] = useState(
//     Object.keys(APP_CONFIG?.METRIC_GROUPS)
//   );

//   // ─────────────────────────────────────────────────────────────
//   // SYNC COMPANIES
//   // ─────────────────────────────────────────────────────────────

//   useEffect(() => {
//     if (!competitorOptions.length) return;

//     setLocalCompanies(
//       mergeUniqueCompanies(competitorOptions).slice(0, MAX_DEFAULT_COMPANIES)
//     );
//   }, [competitorOptions]);

//   // ─────────────────────────────────────────────────────────────
//   // SYNC METRIC
//   // ─────────────────────────────────────────────────────────────

//   useEffect(() => {
//     if (!availableMetrics.length) return;

//     if (!localMetric || !availableMetrics.includes(localMetric)) {
//       setLocalMetric(availableMetrics[0]);
//     }
//   }, [availableMetrics]);

//   // ─────────────────────────────────────────────────────────────
//   // CHART DATA
//   // ─────────────────────────────────────────────────────────────

//   const chartData = useMemo(() => {
//     if (!financialData?.length || !localCompanies?.length || !localMetric) {
//       return [];
//     }

//     const yearMap = new Map();

//     localCompanies.forEach((comp) => {
//       const companyData = financialData.find(
//         (fd) => fd.vendor_company_id === comp.value
//       );

//       if (!companyData?.rawFinancials?.length) return;

//       const metricBlock = companyData.rawFinancials.find(
//         (m) => m._id === localMetric
//       );

//       if (!metricBlock?.data?.length) return;

//       metricBlock.data.forEach((entry) => {
//         if (
//           entry.value === "Data Unavailable" ||
//           entry.value === null ||
//           entry.value === undefined
//         ) {
//           return;
//         }

//         const year = String(entry.year);

//         if (!yearMap.has(year)) {
//           yearMap.set(year, { year });
//         }

//         yearMap.get(year)[comp.label] = Number(entry.value) / 100000;
//       });
//     });

//     return Array.from(yearMap.values()).sort(
//       (a, b) => Number(a.year) - Number(b.year)
//     );
//   }, [financialData, localCompanies, localMetric]);

//   // ─────────────────────────────────────────────────────────────
//   // CHART
//   // ─────────────────────────────────────────────────────────────

//   useLayoutEffect(() => {
//     // if (!chartData.length || !localCompanies.length || !localMetric) {
//     //   return;
//     // }

//     if (!chartData.length || !localCompanies.length || !localMetric) {
//       return;
//     }

//     let root = am5.Root.new(chartRef.current);

//     root._logo.dispose();

//     root.setThemes([am5themes_Animated.new(root)]);

//     let chart = root.container.children.push(
//       am5xy.XYChart.new(root, {
//         layout: root.verticalLayout,

//         panX: false,
//         panY: false,

//         wheelX: "none",
//         wheelY: "none",

//         paddingTop: 20,
//         paddingBottom: 20,
//         paddingLeft: 20,
//         paddingRight: 20,
//       })
//     );

//     // X AXIS

//     let xAxis = chart.xAxes.push(
//       am5xy.CategoryAxis.new(root, {
//         categoryField: "year",

//         renderer: am5xy.AxisRendererX.new(root, {
//           minGridDistance: 40,
//         }),
//       })
//     );

//     xAxis.get("renderer").labels.template.setAll({
//       paddingTop: 10,
//       textAlign: "center",
//     });

//     xAxis.data.setAll(chartData);

//     // Y AXIS

//     let yAxis = chart.yAxes.push(
//       am5xy.ValueAxis.new(root, {
//         renderer: am5xy.AxisRendererY.new(root, {}),
//         min: 0,
//       })
//     );

//     yAxis.get("renderer").labels.template.setAll({
//       paddingRight: 10,
//     });

//     yAxis.get("renderer").labels.template.adapters.add("text", (text) => {
//       return text ? text + "B" : text;
//       // return text;
//     });

//     // SERIES

//     localCompanies.forEach((comp, idx) => {
//       const color = LINE_COLORS[idx % LINE_COLORS.length];

//       let series = chart.series.push(
//         am5xy.LineSeries.new(root, {
//           name: comp.label,

//           xAxis,
//           yAxis,

//           valueYField: comp.label,
//           categoryXField: "year",

//           stroke: am5.color(color),
//           fill: am5.color(color),

//           tooltip: am5.Tooltip.new(root, {
//             // labelText: "{name}: {valueY}B",
//             labelText: "{name}: {valueY}",
//           }),
//         })
//       );

//       series.strokes.template.setAll({
//         strokeWidth: 3,
//       });

//       series.bullets.push(() =>
//         am5.Bullet.new(root, {
//           sprite: am5.Circle.new(root, {
//             radius: 5,
//             fill: am5.color(color),
//             stroke: am5.color(0xffffff),
//             strokeWidth: 2,
//           }),
//         })
//       );

//       series.data.setAll(chartData);
//     });

//     // CURSOR

//     chart.set(
//       "cursor",
//       am5xy.XYCursor.new(root, {
//         behavior: "none",
//       })
//     );

//     // LEGEND

//     let legend = chart.children.push(
//       am5.Legend.new(root, {
//         centerX: am5.p50,
//         x: am5.p50,

//         layout: root.horizontalLayout,

//         paddingTop: 15,
//         paddingBottom: 10,
//       })
//     );

//     legend.labels.template.setAll({
//       paddingLeft: 8,
//       paddingRight: 8,
//     });

//     legend.itemContainers.template.setAll({
//       paddingRight: 15,
//       paddingTop: 5,
//       paddingBottom: 5,
//     });

//     legend.data.setAll(chart.series.values);

//     chart.appear(1000, 100);

//     return () => {
//       root.dispose();
//     };
//   }, [chartData, localCompanies, localMetric]);

//   // ─────────────────────────────────────────────────────────────
//   // HELPERS
//   // ─────────────────────────────────────────────────────────────

//   const toggleCompany = (comp) => {
//     setLocalCompanies((prev) => {
//       const exists = prev.find((c) => c.value === comp.value);

//       if (exists) {
//         return prev.filter((c) => c.value !== comp.value);
//       }

//       return mergeUniqueCompanies(prev, [comp]);
//     });
//   };

//   const visibleSelectedCompanies = showAllSelectedCompanies
//     ? localCompanies
//     : localCompanies.slice(0, PANEL_SHOW_DEFAULT);

//   // if (!financialData.length) return null;

//   if (!financialData.length) {
//     return <div className="mt-4">No financial data available</div>;
//   }

//   return (
//     <div className="container mt-4 heatmap_wrapper">
//       <h3 className="mb-3 heatmap_head">Financial Performance - Line Chart</h3>

//       {/* FILTER BUTTONS */}

//       <div className="d-flex align-items-center flex-wrap heatmap_dropdown_block">
//         <button
//           // className="btn mt-4 ml-3 heatmap_filter_metrics"
//           className="btn mt-4 heatmap_filter_metrics"
//           onClick={() => {
//             setShowCompanyFilter((prev) => !prev);
//             setShowMetricFilter(false);
//           }}
//         >
//           Filter Companies
//         </button>

//         <button
//           className="btn mt-4 ml-3 heatmap_filter_metrics"
//           onClick={() => {
//             setShowMetricFilter((prev) => !prev);
//             setShowCompanyFilter(false);
//           }}
//         >
//           Select Metric
//         </button>
//       </div>

//       {/* COMPANY FILTER */}

//       {showCompanyFilter && (
//         <div className="card p-3 mt-3 select_heatmap_card">
//           <label className="font14 fw-medium mb-2 select_heatmap_card_label">
//             Select Companies
//           </label>

//           <Select
//             isMulti
//             options={mergeUniqueCompanies(competitorOptions)}
//             value={localCompanies}
//             className="font13 search_competitors_select"
//             placeholder="Search companies..."
//             closeMenuOnSelect={false}
//             isClearable={false}
//             backspaceRemovesValue={false}
//             hideSelectedOptions={false}
//             components={{
//               Option: CheckboxOption,
//             }}
//             controlShouldRenderValue={false}
//             onChange={(list) => setLocalCompanies(list || [])}
//           />

//           <div className="mt-3 select_heatmap_apply_block">
//             <button
//               className="btn btn-light btn-sm ml-2 select_heatmap_cancel_btn"
//               onClick={() => setShowCompanyFilter(false)}
//             >
//               Close
//             </button>
//           </div>

//           <small className="text-muted mt-2">
//             Selected: {localCompanies.length}
//           </small>
//         </div>
//       )}

//       {/* METRIC FILTER */}

//       {showMetricFilter && (
//         <div className="card p-3 mt-3 select_heatmap_card">
//           <label className="font14 fw-medium mb-2 select_heatmap_card_label">
//             Select Metric
//           </label>

//           {/* <Select
//             options={[...new Set(availableMetrics)].map((m) => ({
//               label: formatMetricLabel(m),
//               value: m,
//             }))}
//             value={
//               localMetric
//                 ? {
//                     label: formatMetricLabel(localMetric),
//                     value: localMetric,
//                   }
//                 : null
//             }
//             placeholder="Search metric..."
//             className="font13 search_competitors_select"
//             isClearable={false}
//             onChange={(selected) => {
//               setLocalMetric(selected?.value || null);
//             }}
//           /> */}

//           <Select
//             options={groupedMetricOptions}
//             value={
//               localMetric
//                 ? groupedMetricOptions
//                     .flatMap((group) => group.options)
//                     .find((opt) => opt.value === localMetric)
//                 : null
//             }
//             placeholder="Search metric..."
//             className="font13 search_competitors_select"
//             isClearable={false}
//             closeMenuOnSelect={true}
//             hideSelectedOptions={false}
//             controlShouldRenderValue={true}
//             onChange={(selected) => {
//               setLocalMetric(selected?.value || null);
//             }}
//             components={{
//               Option: CheckboxOption,
//               MenuList: CollapsibleMenuList,
//             }}
//             collapsedGroups={collapsedGroups}
//             setCollapsedGroups={setCollapsedGroups}
//           />

//           <div className="mt-3 select_heatmap_apply_block">
//             <button
//               className="btn btn-light btn-sm ml-2 select_heatmap_cancel_btn"
//               onClick={() => setShowMetricFilter(false)}
//             >
//               Close
//             </button>
//           </div>

//           <small className="text-muted mt-2">
//             Selected: {localMetric ? 1 : 0}
//           </small>
//         </div>
//       )}

//       {/* ACTIVE METRIC */}

//       {localMetric && (
//         <div className="mt-2 selected_companies_block">
//           <label className="form-label fw-medium selected_companies_lable">
//             Active Metric
//           </label>

//           <div className="d-flex flex-wrap selected_companies_tags">
//             <div className="badge badge-primary p-2 mr-2 mb-2 d-flex align-items-center selected_companies_badges">
//               {formatMetricLabel(localMetric)}
//             </div>
//           </div>
//         </div>
//       )}

//       {/* ACTIVE COMPANIES */}

//       {localCompanies.length > 0 && (
//         <div className="mt-2 selected_companies_block">
//           <label className="form-label fw-medium selected_companies_lable">
//             Showing Companies
//           </label>

//           <div className="d-flex flex-wrap selected_companies_tags">
//             {visibleSelectedCompanies.map((comp) => (
//               <div
//                 key={comp.value}
//                 className="badge badge-primary p-2 mr-2 mb-2 d-flex align-items-center selected_companies_badges"
//               >
//                 {comp.label}

//                 <span
//                   className="ml-2"
//                   style={{
//                     cursor: "pointer",
//                     fontWeight: "bold",
//                   }}
//                   onClick={() => toggleCompany(comp)}
//                 >
//                   ×
//                 </span>
//               </div>
//             ))}
//           </div>

//           {localCompanies.length > PANEL_SHOW_DEFAULT && (
//             <button
//               className="btn btn-link btn-sm p-0 mt-1 select_heatmap_cancel_btn"
//               onClick={() => setShowAllSelectedCompanies((prev) => !prev)}
//             >
//               {showAllSelectedCompanies
//                 ? "Show Less"
//                 : `Show More (${
//                     localCompanies.length - PANEL_SHOW_DEFAULT
//                   } more)`}
//             </button>
//           )}
//         </div>
//       )}

//       {/* CHART */}

//       <div
//         ref={chartRef}
//         style={{
//           width: "100%",
//           height: "400px",
//         }}
//       />
//     </div>
//   );
// };

// export default MultiLineChart;

import React, {
  useLayoutEffect,
  useRef,
  useState,
  useEffect,
  useMemo,
} from "react";

import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import * as FeatherIcon from "react-feather";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import APP_CONFIG from "../config/appConfig";
import Select, { components } from "react-select";

const MAX_DEFAULT_COMPANIES = 3;
const PANEL_SHOW_DEFAULT = 5;
const DEFAULT_METRIC = "IQ_EBITDA";
// ++++++++++++++++++++++++++++++++++++++++++++++

const buildGroupedMetricOptions = (availableMetrics) => {
  return Object.entries(APP_CONFIG?.METRIC_GROUPS)
    .map(([group, metrics]) => {
      const options = metrics
        .filter((metric) => availableMetrics.includes(metric))
        .map((metric) => ({
          label: formatMetricLabel(metric),
          value: metric,
        }));

      return options.length
        ? {
            label: group,
            options,
          }
        : null;
    })
    .filter(Boolean);
};

const CollapsibleMenuList = (props) => {
  const { children, selectProps } = props;

  const { collapsedGroups, setCollapsedGroups } = selectProps;

  return (
    <components.MenuList {...props}>
      {React.Children.map(children, (group) => {
        if (!group?.props?.data) return group;

        const label = group.props.data.label;

        const isCollapsed = collapsedGroups?.includes(label);

        return (
          <div>
            <div
              onClick={(e) => {
                e.stopPropagation();

                setCollapsedGroups((prev) =>
                  isCollapsed
                    ? prev.filter((g) => g !== label)
                    : [...prev, label]
                );
              }}
              style={{
                cursor: "pointer",
                fontWeight: 600,
                padding: "8px 12px",
                background: "#f8f9fa",
                borderBottom: "1px solid #eee",
              }}
            >
              {isCollapsed ? (
                <FeatherIcon.ChevronRight width={16} className="" />
              ) : (
                <FeatherIcon.ChevronDown width={16} className="" />
              )}{" "}
              {label}
            </div>

            {!isCollapsed && group}
          </div>
        );
      })}
    </components.MenuList>
  );
};

// +++++++++++++++++++++++++++++++++++++++++++++++++++++++

const LINE_COLORS = [
  0x7b6ff0, 0x27ae60, 0xf39c12, 0xe74c3c, 0x2980b9, 0x8e44ad, 0x16a085,
  0xd35400,
];

const formatMetricLabel = (metric) =>
  APP_CONFIG?.METRICS_WITH_NAMES[metric] || metric.replace(/IQ_|_/g, " ");

const mergeUniqueCompanies = (...lists) => {
  const map = new Map();

  lists.flat().forEach((c) => {
    if (c && !map.has(c.value)) {
      map.set(c.value, c);
    }
  });

  return Array.from(map.values());
};

const CheckboxOption = (props) => {
  return (
    <components.Option {...props}>
      <input
        type="checkbox"
        checked={props.isSelected}
        onChange={() => null}
        style={{ marginRight: 8 }}
      />
      {props.label}
    </components.Option>
  );
};

const deriveAvailableMetrics = (financialData) => {
  if (!financialData?.length) return [];

  const metricSet = new Set();

  financialData.forEach((company) => {
    // company.metrics?.forEach((m) => {
    company.rawFinancials?.forEach((m) => {
      // if (m.metric && m.value !== null && m.value !== undefined) {
      if (m._id) {
        metricSet.add(m._id);
      }
    });
  });

  return Array.from(metricSet);
};

const LEGEND_ITEMS_PER_ROW = 3;
const MAX_LEGEND_LINES = 1;
const MAX_VISIBLE_LEGEND_ITEMS = LEGEND_ITEMS_PER_ROW * MAX_LEGEND_LINES;

const MultiLineChart = ({ financialData = [], competitorOptions = [] }) => {
  const chartRef = useRef(null);

  const availableMetrics = useMemo(
    () => deriveAvailableMetrics(financialData),
    [financialData]
  );

  const groupedMetricOptions = useMemo(
    () => buildGroupedMetricOptions([...new Set(availableMetrics)]),
    [availableMetrics]
  );

  // ─────────────────────────────────────────────────────────────
  // LOCAL STATES
  // ─────────────────────────────────────────────────────────────

  const [localCompanies, setLocalCompanies] = useState(() =>
    mergeUniqueCompanies(competitorOptions).slice(0, MAX_DEFAULT_COMPANIES)
  );

  // const [localMetric, setLocalMetric] = useState(
  //   () => availableMetrics[0] || null
  // );

  const [localMetric, setLocalMetric] = useState(() =>
    availableMetrics.includes(DEFAULT_METRIC)
      ? DEFAULT_METRIC
      : availableMetrics[0] || null
  );

  const [showCompanyFilter, setShowCompanyFilter] = useState(false);

  const [showMetricFilter, setShowMetricFilter] = useState(false);

  const [showAllSelectedCompanies, setShowAllSelectedCompanies] =
    useState(false);

  const [collapsedGroups, setCollapsedGroups] = useState(
    Object.keys(APP_CONFIG?.METRIC_GROUPS)
  );

  const [legendExpanded, setLegendExpanded] = useState(false);

  // ─────────────────────────────────────────────────────────────
  // SYNC COMPANIES
  // ─────────────────────────────────────────────────────────────

  useEffect(() => {
    if (!competitorOptions.length) return;

    setLocalCompanies(
      mergeUniqueCompanies(competitorOptions).slice(0, MAX_DEFAULT_COMPANIES)
    );
  }, [competitorOptions]);

  // ─────────────────────────────────────────────────────────────
  // SYNC METRIC
  // ─────────────────────────────────────────────────────────────

  // useEffect(() => {
  //   if (!availableMetrics.length) return;

  //   if (!localMetric || !availableMetrics.includes(localMetric)) {
  //     setLocalMetric(availableMetrics[0]);
  //   }
  // }, [availableMetrics]);

  useEffect(() => {
    if (!availableMetrics.length) return;

    if (!localMetric || !availableMetrics.includes(localMetric)) {
      setLocalMetric(
        availableMetrics.includes(DEFAULT_METRIC)
          ? DEFAULT_METRIC
          : availableMetrics[0]
      );
    }
  }, [availableMetrics]);

  // ─────────────────────────────────────────────────────────────
  // CHART DATA
  // ─────────────────────────────────────────────────────────────

  const chartData = useMemo(() => {
    if (!financialData?.length || !localCompanies?.length || !localMetric) {
      return [];
    }

    const yearMap = new Map();

    localCompanies.forEach((comp) => {
      const companyData = financialData.find(
        (fd) => fd.vendor_company_id === comp.value
      );

      if (!companyData?.rawFinancials?.length) return;

      const metricBlock = companyData.rawFinancials.find(
        (m) => m._id === localMetric
      );

      if (!metricBlock?.data?.length) return;

      metricBlock.data.forEach((entry) => {
        if (
          entry.value === "Data Unavailable" ||
          entry.value === null ||
          entry.value === undefined
        ) {
          return;
        }

        const year = String(entry.year);

        if (!yearMap.has(year)) {
          yearMap.set(year, { year });
        }

        // yearMap.get(year)[comp.label] = Number(entry.value) / 100000;
        yearMap.get(year)[comp.label] = Number(entry.value);
      });
    });

    return Array.from(yearMap.values()).sort(
      (a, b) => Number(a.year) - Number(b.year)
    );
  }, [financialData, localCompanies, localMetric]);

  // ─────────────────────────────────────────────────────────────
  // CHART
  // ─────────────────────────────────────────────────────────────

  useLayoutEffect(() => {
    // if (!chartData.length || !localCompanies.length || !localMetric) {
    //   return;
    // }

    if (!chartData.length || !localCompanies.length || !localMetric) {
      return;
    }

    let root = am5.Root.new(chartRef.current);

    root._logo.dispose();

    root.setThemes([am5themes_Animated.new(root)]);

    let chart = root.container.children.push(
      am5xy.XYChart.new(root, {
        layout: root.verticalLayout,

        panX: false,
        panY: false,

        wheelX: "none",
        wheelY: "none",

        paddingTop: 20,
        paddingBottom: 20,
        paddingLeft: 20,
        paddingRight: 20,
      })
    );

    // X AXIS

    let xAxis = chart.xAxes.push(
      am5xy.CategoryAxis.new(root, {
        categoryField: "year",

        renderer: am5xy.AxisRendererX.new(root, {
          minGridDistance: 40,
        }),
      })
    );

    xAxis.get("renderer").labels.template.setAll({
      paddingTop: 10,
      fontSize: 12,
      textAlign: "center",
    });

    xAxis.data.setAll(chartData);

    // Y AXIS

    let yAxis = chart.yAxes.push(
      am5xy.ValueAxis.new(root, {
        renderer: am5xy.AxisRendererY.new(root, {}),
        min: 0,
      })
    );

    yAxis.get("renderer").labels.template.setAll({
      paddingRight: 10,
      fontSize: 12,
    });

    yAxis.children.unshift(
      am5.Label.new(root, {
        rotation: -90,
        text: "Values in Millions",
        y: am5.p50,
        centerX: am5.p50,
        centerY: am5.p50,
        paddingRight: 15,
        fontSize: 11,
      })
    );

    yAxis.get("renderer").labels.template.adapters.add("text", (text) => {
      // return text ? text + "B" : text;
      return text;
    });

    // SERIES

    localCompanies.forEach((comp, idx) => {
      const color = LINE_COLORS[idx % LINE_COLORS.length];

      let series = chart.series.push(
        am5xy.LineSeries.new(root, {
          name: comp.label,

          xAxis,
          yAxis,

          valueYField: comp.label,
          categoryXField: "year",

          stroke: am5.color(color),
          fill: am5.color(color),

          // tooltip: am5.Tooltip.new(root, {
          //   // labelText: "{name}: {valueY}B",
          //   labelText: "{name}: {valueY}",
          // }),

          tooltip: (() => {
            const tooltip = am5.Tooltip.new(root, {
              labelText: "{name}: {valueY}",
            });

            tooltip.label.setAll({
              fontSize: 12,
            });

            return tooltip;
          })(),
        })
      );

      series.strokes.template.setAll({
        strokeWidth: 3,
      });

      series.bullets.push(() =>
        am5.Bullet.new(root, {
          sprite: am5.Circle.new(root, {
            radius: 5,
            fill: am5.color(color),
            stroke: am5.color(0xffffff),
            strokeWidth: 2,
          }),
        })
      );

      series.data.setAll(chartData);
    });

    // CURSOR

    chart.set(
      "cursor",
      am5xy.XYCursor.new(root, {
        behavior: "none",
      })
    );

    // LEGEND

    // let legend = chart.children.push(
    //   am5.Legend.new(root, {
    //     centerX: am5.p50,
    //     x: am5.p50,

    //     layout: root.horizontalLayout,
    //     fontSize: 12,
    //     paddingTop: 15,
    //     paddingBottom: 10,
    //   })
    // );

    // legend.labels.template.setAll({
    //   fontSize: 12,
    //   paddingLeft: 8,
    //   paddingRight: 8,
    // });

    // legend.itemContainers.template.setAll({
    //   paddingRight: 15,
    //   paddingTop: 5,
    //   paddingBottom: 5,
    // });

    // legend.data.setAll(chart.series.values);

    // LEGEND
    const allSeries = chart.series.values;
    const visibleSeries = legendExpanded
      ? allSeries
      : allSeries.slice(0, MAX_VISIBLE_LEGEND_ITEMS);

    let legend = chart.children.push(
      am5.Legend.new(root, {
        centerX: am5.p50,
        x: am5.p50,
        width: am5.percent(100),
        layout: root.gridLayout,
        useDefaultMarker: true,
        paddingTop: 15,
        paddingBottom: 10,
      })
    );

    legend.itemContainers.template.setAll({
      width: am5.percent(33),
      paddingBottom: 8,
      paddingTop: 8,
    });

    legend.labels.template.setAll({
      fontSize: 12,
      paddingLeft: 8,
      paddingRight: 8,
      maxWidth: 220,
      breakWords: true,
    });

    legend.markerRectangles.template.setAll({
      cornerRadiusTL: 4,
      cornerRadiusTR: 4,
      cornerRadiusBL: 4,
      cornerRadiusBR: 4,
    });

    legend.data.setAll(visibleSeries);

    chart.appear(1000, 100);

    return () => {
      root.dispose();
    };
  }, [chartData, localCompanies, localMetric, legendExpanded]);

  // ─────────────────────────────────────────────────────────────
  // HELPERS
  // ─────────────────────────────────────────────────────────────

  const toggleCompany = (comp) => {
    setLocalCompanies((prev) => {
      const exists = prev.find((c) => c.value === comp.value);

      if (exists) {
        return prev.filter((c) => c.value !== comp.value);
      }

      return mergeUniqueCompanies(prev, [comp]);
    });
  };

  const visibleSelectedCompanies = showAllSelectedCompanies
    ? localCompanies
    : localCompanies.slice(0, PANEL_SHOW_DEFAULT);

  // if (!financialData.length) return null;

  const sortedGroupedMetricOptions = useMemo(() => {
    return groupedMetricOptions.map((group) => {
      const selected = [];
      const unselected = [];

      group.options.forEach((option) => {
        if (option.value === localMetric) {
          selected.push(option);
        } else {
          unselected.push(option);
        }
      });

      return {
        ...group,
        options: [...selected, ...unselected],
      };
    });
  }, [groupedMetricOptions, localMetric]);

  if (!financialData.length) {
    return <div className="mt-4 ml-2">No financial data available</div>;
  }

  return (
    <div className="container heatmap_wrapper" style={{ marginTop: "30px" }}>
      <h3 className="mb-0 heatmap_head">Financial Performance - Line Chart</h3>

      {/* FILTER BUTTONS */}

      <div className="d-flex align-items-center flex-wrap heatmap_dropdown_block">
        <button
          // className="btn mt-4 ml-3 heatmap_filter_metrics"
          className="btn mt-2 heatmap_filter_metrics"
          onClick={() => {
            setShowCompanyFilter((prev) => !prev);
            setShowMetricFilter(false);
          }}
        >
          Filter Companies
        </button>

        <button
          className="btn mt-2 ml-3 heatmap_filter_metrics"
          onClick={() => {
            setShowMetricFilter((prev) => !prev);
            setShowCompanyFilter(false);
          }}
        >
          Select Metric
        </button>
      </div>

      {/* COMPANY FILTER */}

      {showCompanyFilter && (
        <div className="card p-3 mt-3 select_heatmap_card">
          <label className="font14 fw-medium mb-2 select_heatmap_card_label">
            Select Companies
          </label>

          <Select
            isMulti
            options={mergeUniqueCompanies(competitorOptions)}
            value={localCompanies}
            className="font13 search_competitors_select"
            styles={APP_CONFIG?.CUSTOM_SELECT_STYLES}
            placeholder="Search companies..."
            closeMenuOnSelect={false}
            isClearable={false}
            backspaceRemovesValue={false}
            hideSelectedOptions={false}
            components={{
              Option: CheckboxOption,
            }}
            controlShouldRenderValue={false}
            onChange={(list) => setLocalCompanies(list || [])}
          />

          <div className="mt-3 select_heatmap_apply_block">
            <button
              className="btn btn-light btn-sm select_heatmap_cancel_btn"
              onClick={() => setShowCompanyFilter(false)}
            >
              Close
            </button>
          </div>

          <small className="text-muted mt-2">
            Selected: {localCompanies.length}
          </small>
        </div>
      )}

      {/* METRIC FILTER */}

      {showMetricFilter && (
        <div className="card p-3 mt-3 select_heatmap_card">
          <label className="font14 fw-medium mb-2 select_heatmap_card_label">
            Select Metric
          </label>

          {/* <Select
            options={[...new Set(availableMetrics)].map((m) => ({
              label: formatMetricLabel(m),
              value: m,
            }))}
            value={
              localMetric
                ? {
                    label: formatMetricLabel(localMetric),
                    value: localMetric,
                  }
                : null
            }
            placeholder="Search metric..."
            className="font13 search_competitors_select"
            isClearable={false}
            onChange={(selected) => {
              setLocalMetric(selected?.value || null);
            }}
          /> */}

          {/* <Select
            options={groupedMetricOptions}
            value={
              localMetric
                ? groupedMetricOptions
                    .flatMap((group) => group.options)
                    .find((opt) => opt.value === localMetric)
                : null
            }
            placeholder="Search metric..."
            className="font13 search_competitors_select"
            isClearable={false}
            closeMenuOnSelect={true}
            hideSelectedOptions={false}
            controlShouldRenderValue={true}
            onChange={(selected) => {
              setLocalMetric(selected?.value || null);
            }}
            // components={{
            //   Option: CheckboxOption,
            //   MenuList: CollapsibleMenuList,
            // }}
            components={{
              MenuList: CollapsibleMenuList,
            }}
            collapsedGroups={collapsedGroups}
            setCollapsedGroups={setCollapsedGroups}
          /> */}

          <Select
            options={sortedGroupedMetricOptions}
            value={
              localMetric
                ? sortedGroupedMetricOptions
                    .flatMap((group) => group.options)
                    .find((opt) => opt.value === localMetric)
                : null
            }
            placeholder="Search metric..."
            className="font13 search_competitors_select"
            styles={APP_CONFIG?.CUSTOM_SELECT_STYLES}
            isClearable={false}
            closeMenuOnSelect={true}
            hideSelectedOptions={false}
            controlShouldRenderValue={true}
            onChange={(selected) => {
              setLocalMetric(selected?.value || null);
            }}
            components={{
              MenuList: CollapsibleMenuList,
            }}
            collapsedGroups={collapsedGroups}
            setCollapsedGroups={setCollapsedGroups}
          />

          <div className="mt-3 select_heatmap_apply_block">
            <button
              className="btn btn-light btn-sm  select_heatmap_cancel_btn"
              onClick={() => setShowMetricFilter(false)}
            >
              Close
            </button>
          </div>

          <small className="text-muted mt-2">
            Selected: {localMetric ? 1 : 0}
          </small>
        </div>
      )}

      {/* ACTIVE METRIC */}

      {localMetric && (
        <div className="mt-2 selected_companies_block">
          <label className="form-label fw-medium selected_companies_lable">
            Active Metric
          </label>

          <div className="d-flex flex-wrap selected_companies_tags">
            <div className="badge badge-primary p-2 mr-2 mb-2 d-flex align-items-center selected_companies_badges">
              {formatMetricLabel(localMetric)}
            </div>
          </div>
        </div>
      )}

      {/* ACTIVE COMPANIES */}

      {localCompanies.length > 0 && (
        <div className="mt-2 selected_companies_block">
          <label className="form-label fw-medium selected_companies_lable">
            Showing Companies
          </label>

          <div className="d-flex flex-wrap selected_companies_tags">
            {visibleSelectedCompanies.map((comp) => (
              <div
                key={comp.value}
                className="badge badge-primary p-2 mr-2 mb-2 d-flex align-items-center selected_companies_badges"
              >
                {comp.label}

                <span
                  className="ml-2"
                  style={{
                    cursor: "pointer",
                    fontWeight: "bold",
                  }}
                  onClick={() => toggleCompany(comp)}
                >
                  ×
                </span>
              </div>
            ))}
          </div>

          {localCompanies.length > PANEL_SHOW_DEFAULT && (
            <button
              className="btn p-0 mt-1 show_more_finacial"
              onClick={() => setShowAllSelectedCompanies((prev) => !prev)}
            >
              {showAllSelectedCompanies
                ? "Show Less"
                : `Show More (${
                    localCompanies.length - PANEL_SHOW_DEFAULT
                  } more)`}
            </button>
          )}
        </div>
      )}

      {/* CHART */}

      <div
        ref={chartRef}
        style={{
          width: "100%",
          height: "400px",
        }}
      />

      {localCompanies.length > MAX_VISIBLE_LEGEND_ITEMS && (
        <button
          className="btn p-0 mt-1 show_more_finacial"
          onClick={() => setLegendExpanded((prev) => !prev)}
        >
          {legendExpanded
            ? "Show Less"
            : `Show More (${
                localCompanies.length - MAX_VISIBLE_LEGEND_ITEMS
              } more)`}
        </button>
      )}
    </div>
  );
};

export default MultiLineChart;
